import { createUseStyles } from "react-jss";
import {colors} from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles({
  mainDiv: {
    "& .row": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        display:"grid",
      }
    },
    "& .col-md-4": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        marginBottom: "32px"
      }
    },
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
  },
  personalDetails:{
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  formContainer:{
    width: "512px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    }
  },
  inputContainer:{
    display:"flex",
    flexDirection:"column",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      textOverflow: "ellipsis",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  label:{
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px"
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  buttonContainer:{
    display: "flex",
    justifyContent:"flex-end",
    marginBottom:"30px"
  },
  btnContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center"
  },
  button:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight:"12px",
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "5px",
    cursor: "pointer",
    padding: "unset",
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
  roleTooltipItem: {
    fontWeight:500
  },
  roleTooltipTitle:{
    marginBottom: "4px",
    fontWeight:600
  },
  roleTooltipAdmin: {
    marginBottom: "12px",
    fontWeight:500
  },
  roles: {
    textAlign:"left",
    height:"44px",
  },
  rolesWrapper: {
    marginBottom:"16px",
  },
  sourceDetails: {
    marginTop: "16px",
    fontSize: "14px",
    fontWeight:"400",
    lineHeight:"20px",
    color: colors.mediumGrey,
  }
});

export default styles;